// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remote-terminal[data-v-6aad9612] {\n  background-color: black;\n  color: white;\n  padding: 3%;\n  border-radius: 2%;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
